import React from 'react';
import './ErrorHelper.css';
import Utils from '@/common/utils/utils';

export default function ErrorHelper({
  isShowError = false,
  textError = '',
  isShowNoticeIcon = true,
  customCss = {}
}) {
  return (
      <>
          {isShowError && (
              <div className="error-helper-common">
                  {isShowNoticeIcon && (
                      <img
                          src="/assets/image/error-notice.svg"
                          alt=""
                          style={
                              !Utils.isEmptyObject(customCss) &&
                              !Utils.isEmptyObject(customCss.customImg) ? {
                                  ...customCss.customImg
                              } : {}
                          }
                      />
                  )}
                  <div
                      style={
                          !Utils.isEmptyObject(customCss) &&
                          !Utils.isEmptyObject(customCss.customText) ? {
                              ...customCss.customText
                          } : {}
                      }
                  >
                      {textError}
                  </div>
              </div>
          )}
      </>
  );
}

